import { render } from "./indexAdd.vue?vue&type=template&id=20763766"
import script from "./indexAdd.vue?vue&type=script&lang=js"
export * from "./indexAdd.vue?vue&type=script&lang=js"

import "./indexAdd.vue?vue&type=style&index=0&id=20763766&lang=less"
script.render = render

export default script